import { api } from "../../lib";

export interface Permission {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
}

export interface CreatePermissionInput {
  name: string;
  description?: string;
}

export interface UpdatePermissionInput extends Partial<CreatePermissionInput> {
  id: string;
}

export const permissionsService = {
  getAll: async () => {
    return api.get<Permission[]>("/admin/permissions");
  },

  getById: async (id: string) => {
    return api.get<Permission>(`/admin/permissions/${id}`);
  },

  create: async (input: CreatePermissionInput) => {
    return api.post<Permission>("/admin/permissions", input);
  },

  update: async (input: UpdatePermissionInput) => {
    const { id, ...updates } = input;
    return api.put<Permission>(`/admin/permissions/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/permissions/${id}`);
  },
};
